export default [
  {
    width: 16,
    header: {
      type: 'text',
      caption: 'Date',
      sort: 'dateCreated',
    },
    cell: {
      type: 'slot',
      name: 'date',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Action',
    },
    cell: {
      type: 'slot',
      name: 'action',
    },
  },
  {
    width: 16,
    header: {
      type: 'text',
      caption: 'Unblocked',
    },
    cell: {
      type: 'slot',
      name: 'unblocked',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Initiator',
    },
    cell: {
      type: 'slot',
      name: 'initiator',
    },
  },
  {
    width: 37,
    header: {
      type: 'text',
      caption: 'Reason',
    },
    cell: {
      type: 'slot',
      name: 'reason',
    },
  },
];
